import { Box, Button, Card, Dialog as MUIDialog, Stack, TextField, Typography } from "@mui/material";
import { styled } from '@mui/material/styles';

export const BootstrapDialog = styled(MUIDialog)(({ theme }) => ({
  width: "100%",
  "& .MuiDialog-paper": {
    margin: 0, // Removes margin
    padding: 0, // Removes padding
    width: "100%", // Ensures full width
  },
}));

export const StyledTypography = styled(Typography)({
  fontWeight: 500,
  fontSize: 20,
  color: "#0F172A"
});

export const StyledReminderBox = styled(Box)(({ theme }) => ({
  width: 270,
  height: 200,
  marginTop: 7,
  display: 'flex',
  border: "1px solid #575757",
  [theme.breakpoints.up("lg")]: {
    width: 270,
    height: 200,
  },
  [theme.breakpoints.down("lg")]: {
    width: 270,
    height: 200,
  },
  [theme.breakpoints.down("md")]: {
    width:"90%",
    height: 170,
  },
  [theme.breakpoints.down("sm")]: {
    width: "100%",
    height: 141,
  },
  [theme.breakpoints.down("xs")]: {
    width: "100%",
    height: 141,
  },
}));

export const StyledUploadBox = styled(Box)(({ theme }: any) => ({
  width: "100%",
  height: 203,
  marginTop: 7,
  borderRadius: 12,
  display: 'flex',
  alignItems: "center",
  justifyContent: 'center',
  backgroundColor: "white",
  border: "1px dashed #575757",
  [theme.breakpoints.up("lg")]: {
    width: "100%",
    height: 203,
  },
  [theme.breakpoints.down("lg")]: {
    width: "100%",
    height: 203,
  },
  [theme.breakpoints.down("md")]: {
    width:"90%",
    height: 170,
  },
  [theme.breakpoints.down("sm")]: {
    width: "100%",
    height: 203,
  },
  [theme.breakpoints.down("xs")]: {
    width: "100%",
    height: 203,
  },
}));

export const StyledStackRow = styled(Stack)(({ theme }) => ({
  display: 'flex',
  flexDirection: "row",
  alignItems: "flex-start",
  justifyContent: 'space-between',
  gap: "4rem",
}));

export const StyledStackField = styled(Stack)(({ theme }) => ({
  display: 'flex',  
  [theme.breakpoints.up("lg")]: {
    flexDirection: "row",
    alignItems: "center",
  },
  [theme.breakpoints.down("lg")]: {
    flexDirection: "row",
    alignItems: "center",
  },
  [theme.breakpoints.down("md")]: {
    flexDirection: "row",
    alignItems: "center",
  },
  [theme.breakpoints.down("sm")]: {
    flexDirection: "column",
    alignItems: "flex-start",
  },
  [theme.breakpoints.down("xs")]: {
    flexDirection: "column",
    alignItems: "flex-start",
  },
}));

export const StyledInput = styled(TextField)(({ theme }) => ({
  display: 'flex',
  flex: 1,
  marginTop: 4,
}));


export const StyledRow = styled(Stack)(({ theme }) => ({
  flexDirection: "row",
  justifyContent: "space-between",
  gap: 20,
  marginTop: 31,
}));

export const StyledCardContainer = styled(Card)(({ theme }) => ({
  width: 263,
  padding: 12,
  paddingTop: 14,
  paddingBottom: 21,
  border: "2px dashed #DFEAF2",
}));

export const StyledTypographyTitle = styled(Typography)({
  fontFamily: "inter",
  fontWeight: "bold",
  fontSize: 20,
  color: "#2D52C5"
});

export const StyledTypographyDescription = styled(Typography)({
  fontFamily: "inter",
  fontSize: 12,
  marginTop: 18,
  color: "#202224"
});

export const StyledContainer = styled(Box)(({ theme }: any) => ({
  width: "100%",
  height: 147,
  marginTop: 7,
  borderRadius: 12,
  display: 'flex',
  alignItems: "center",
  justifyContent: 'center',
  border: "1px dashed #575757",
  [theme.breakpoints.up("lg")]: {
    width: "100%",
    height: 147,
  },
  [theme.breakpoints.down("lg")]: {
    width: "100%",
    height: 147,
  },
  [theme.breakpoints.down("md")]: {
    width:"90%",
    height: 147,
  },
  [theme.breakpoints.down("sm")]: {
    width: "100%",
    height: 147,
  },
  [theme.breakpoints.down("xs")]: {
    width: "100%",
    height: 147,
  },
}));

export const StyledButtonContainer = styled(Button)(({ theme }: any) => ({
  width: 230,
  height: 40, 
  borderRadius: 4, 
  color: "white", 
  backgroundColor: "#484848", 
  alignSelf: "center", marginTop: 3
}));
